'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CloseOutlined = _interopRequireDefault(require('./lib/icons/CloseOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CloseOutlined;
exports.default = _default;
module.exports = _default;